export default "__VITE_ASSET__BkZ0WVTT__"